import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.TRAINER.TEXT',
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.TRAINER.LIST.DASHBOARD',
    icon: 'home',
    link: '/',
  },
  {
    id: 3,
    label: 'MENUITEMS.TRAINER.LIST.SCHEDULE',
    icon: 'grid',
    link: '/schedule',
  },
  {
    id: 4,
    label: 'MENUITEMS.TRAINER.LIST.CLIENTS',
    icon: 'users',
    link: '/clients',
  },
  {
    id: 5,
    label: 'MENUITEMS.TRAINER.LIST.PROFILE',
    icon: 'user',
    link: '/profile',
  },
];
